import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import axios from 'axios';
import { deleteAuthenticationToken, getAuthenticationToken, setAuth, setAuthenticationToken } from './utils/TokenHandler'
import { getUserProfile } from './utils/userProfile';
import * as serviceWorker from './serviceWorker';

axios.defaults.baseURL = 'https://www.gazhclub.com/necapi/'; //'http://localhost:7231/';'http://185.132.80.4/necapi/';
axios.defaults.headers.common['Authorization'] = (getAuthenticationToken() === null ? null : `Bearer ${getAuthenticationToken().access_token}`);
const createAxiosResponseInterceptor = () => {
  const interceptor = axios.interceptors.response.use(
    (response) => response,
    (error) => {
      // Reject promise if not 401 error
      if (error.response.status !== 401) {
        return Promise.reject(error);
      }

      /*
       * When response code is 401, try to refresh the token.
       * Remove the interceptor so it doesn't loop in case
       * token refresh causes the 401 response
       *
       * Also eject the interceptor to prevent it from working again if the REFRESH request returns 401 too
       */
      axios.interceptors.response.eject(interceptor);

      return axios.post('api/v1/Authorization/RefreshCustomerToken', null, {
        params: {
          userName: getUserProfile().customerUserName,
          access_token: getAuthenticationToken().access_token,
          refresh_token: getAuthenticationToken().refresh_token
        }
      })
        .then((response) => {
          let oldToken = getAuthenticationToken();
          let newToken = {
            "clubId": response.data.clubId,
            "isMerchant": oldToken.isMerchant,
            "merchantId": oldToken.merchantId,
            "userID": response.data.userID,
            "clubPackageName": oldToken.clubPackageName,
            "isGateKeeper": oldToken.isGateKeeper,
            "clubMerchantiCode": oldToken.clubMerchantiCode,
            "access_token": response.data.access_token,
            "refresh_token": response.data.refresh_token,
            "expires_in": response.data.expires_in
          }
          setAuthenticationToken(newToken);          
          setAuth(newToken.access_token);
          error.response.config.headers["Authorization"] =
            "Bearer " + response.data.access_token;
          return axios(error.response.config);
        })
        .catch((error) => {
          deleteAuthenticationToken();
          return Promise.reject(error);
        })
        .finally(createAxiosResponseInterceptor);
    }
  );
};

createAxiosResponseInterceptor();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.register();